export default __webpack_public_path__ + "static/media/update.29e51530.svg";